const MOONPAY_EVENT = 'openMoonPay';
const MOONPAY_OFFER_END = new Date('3/30/22 12:00 am');
const LOCALE = {
  USD: 'en-US',
  EUR: 'es-ES',
  JPY: 'ja-JP',
  AUD: 'en-AU',
  CAD: 'en-CA',
  GBP: 'en-GB'
};
export { LOCALE, MOONPAY_EVENT, MOONPAY_OFFER_END };
